import React, { useState } from 'react';
import { css } from '@emotion/react';
import { Flex, Box, Alert, theme, Text, Button } from '@xometry/xometry_loft';
import { Organization } from '../../../../schema/generated/schema';
import ReactivateTeamModal from '../../../Teams/ReactivateModal';

const AlertPanel = ({
  msg,
  isStaff,
  activeView,
  org,
  refetchInactiveOrganizations,
}: {
  msg: string;
  isStaff: boolean;
  activeView: string;
  org: Organization;
  refetchInactiveOrganizations: () => void;
}) => {
  const [reactivateModalOpen, setReactivateModalOpen] = useState(false);
  return (
    <Alert
      kind={theme.kind.warning}
      border={`1px solid ${theme.colors.yellows[100]}`}
      marginBottom={theme.space[6]}
      css={css`
        gap: ${theme.space[5]};
      `}
    >
      {org?.isArchived && (
        <Flex width="100%" justifyContent="space-between">
          <Flex flexDirection="column">
            <Box
              height={theme.space[5]}
              paddingBottom={theme.space[2]}
              fontWeight={theme.fontWeights.semibold}
            >
              {msg}
            </Box>
            {isStaff && <Box>Click to Reactivate</Box>}
          </Flex>
          {isStaff && (
            <Flex justifyContent="end">
              <Button
                kind={theme.kind.warning}
                scale={theme.scale.small}
                onClick={() => setReactivateModalOpen(true)}
              >
                Reactivate Team
              </Button>
              <ReactivateTeamModal
                setReactivateTeamModalOpen={setReactivateModalOpen}
                reactivateTeamModalOpen={reactivateModalOpen}
                organization={org}
                refetchInactiveOrganizations={refetchInactiveOrganizations}
              />
            </Flex>
          )}
        </Flex>
      )}
      {isStaff && !org?.isArchived && (
        <Box margin="auto">
          <Text>{msg} </Text>
          {activeView === 'sharingDefaultsView' && (
            <Text>Only the user can manage these details. </Text>
          )}
          <Text kind="body-title">
            Org ID {org.id} {org.name}
          </Text>
        </Box>
      )}
      {!isStaff && !org?.isArchived && (
        <>
          <Flex
            id="alert-content-wrapper"
            color={theme.colors.yellows[125]}
            height="100%"
            paddingRight={theme.space[2]}
          >
            <i
              className="fa-solid fa-circle-exclamation fa-xl"
              css={css`
                line-height: initial;
              `}
            />
          </Flex>
          <Flex flexDirection="column">
            <Box
              height={theme.space[5]}
              paddingBottom={theme.space[2]}
              fontWeight={theme.fontWeights.semibold}
            >
              {msg}
            </Box>
            <Box height={theme.space[5]}>
              Contact an Admin to update these details or your level of access.
            </Box>
          </Flex>
        </>
      )}
    </Alert>
  );
};

AlertPanel.defaultProps = {
  isStaff: false,
  activeView: 'teamManagementView',
  org: {},
};

export default AlertPanel;
